import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'app-characters-counter',
  templateUrl: './characters-counter.component.html',
})
export class CharactersCounterComponent implements OnChanges, OnInit {
  @Input() maxChar?: number;
  @Input() hasSegments?: boolean = false;
  @Input() fixedSegments?: number;
  @Input() currentChar?: number;
  @Output() errors = new EventEmitter<string>();

  segments: number = 1;

  ngOnInit() {
    this.recalculateSegments();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentChar'] || changes['maxChar'] || changes['fixedSegments']) {
      this.recalculateSegments();
    }
  }

  private recalculateSegments() {
    if (this.fixedSegments && this.fixedSegments > 0) {
      this.segments = this.fixedSegments;
      return;
    }

    if (this.hasSegments && this.maxChar && this.maxChar > 0) {
      const count = this.currentChar || 0;
      this.segments = Math.max(1, Math.ceil(count / this.maxChar));
      return;
    }

    this.segments = 1;
  }

  get array(): number[] {
    return Array(this.segments)
      .fill(0)
      .map((x, i) => i);
  }

  get totalPartial(): number {
    if (!this.maxChar || this.currentChar === undefined) return 0;
    const partial = this.currentChar - this.maxChar * (this.segments - 1);
    return Math.max(0, partial);
  }
}
